import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { Loader, FlexColumnCenter, Header2 } from '@ubeya/shared-web/components';
import { ReactComponent as EmptyIcon } from '@ubeya/shared-web/assets/empty-state-feed.svg';

const Container = styled(FlexColumnCenter)`
  flex: 1;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  > svg {
    margin-bottom: 20px;
  }
`;

const EmptyState = ({ showLoader, showNoData }) => {
  if (showLoader) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  if (showNoData) {
    return (
      <Container>
        <EmptyIcon />
        <Header2>
          <Trans>noAuditLogs</Trans>
        </Header2>
      </Container>
    );
  }

  return null;
};

export default EmptyState;
